export default __webpack_public_path__ + "static/media/dg-girl.66b015ac.webp";